import { render, staticRenderFns } from "./cricket-serbia-joins-ludimos-family.vue?vue&type=template&id=475613a9&scoped=true&"
var script = {}
import style0 from "./cricket-serbia-joins-ludimos-family.vue?vue&type=style&index=0&id=475613a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475613a9",
  null
  
)

export default component.exports